import { b as n, a as t } from "./addMonths-BDf46gmB.mjs";
function r(s, a) {
  return n(s, -a);
}
function u(s, a) {
  return t(s, -a);
}
export {
  r as a,
  u as s
};
